import React from 'react';
import axios from 'axios';

import Loading from '../../Loading'

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const AddNewSpecialDebtorCategory = ({ closeModal, onReloadTable }) => {
    const [formInfo, setFormInfo] = React.useState({
        category_name: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.category_name) {
            newErrors.category_name = 'Обязательное поле';
        }
        if (formInfo.category_name && (formInfo.category_name.length < 2 || formInfo.category_name.length > 200)) {
            newErrors.category_name = 'Значение не может быть меньше 2 и более 200 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        axios.put('/api/add-new-special-debtor-category', {
            category_name: formInfo.category_name,
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onReloadTable();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            addData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Добавление специальной категории должников</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Название специальной категории должников</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.category_name} 
                                onChange={handleChange('category_name')} 
                                className={errorsForm.category_name ? 'inputError' : ''}
                                placeholder='Название без сокращений' 
                                minLength='' 
                                maxLength='150' 
                                disabled={loading}
                                required />
                                {errorsForm.category_name && <div className='errorUnderInput'>{errorsForm.category_name}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Добавить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddNewSpecialDebtorCategory;